var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('page-main',{attrs:{"tableData":_vm.tableData,"tablePage":_vm.page,"loading":_vm.loading},on:{"reload":_vm.reload}},[_c('page-header',{ref:"header",attrs:{"slot":"header"},on:{"query":_vm.getData},slot:"header"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }